module.exports = __webpack_public_path__ + "static/media/telegram.5261fd64.png";